export const isLogedIn = (state) => {
  return state.loginInfo !== null ? !state.loginInfo.kariPasswordLoginFlg : false
}

export const userName = (state) => {
  return state.loginInfo ? state.loginInfo.jininNmSei && state.loginInfo.jininNmMei ? `${state.loginInfo.jininNmSei} ${state.loginInfo.jininNmMei}` : `${state.loginInfo.jininNmSei}` : ''
}

export const userId = (state) => {
  return state.loginInfo ? state.loginInfo.id : null
}

export const kengenGroupCd = (state) => {
  console.log('kengenGroupCd', state.loginInfo)
  return state.loginInfo ? state.loginInfo.kengenGroupCd : ''
}

export const eigyoshoCd = (state) => {
  return state.loginInfo ? state.loginInfo.eigyoshoCd : ''
}

export const currentKaishaCode = (state) => {
  return state.loginInfo ? state.loginInfo.kaishaCd : ''
}

export const currentUserCode = (state) => {
  return state.loginInfo ? state.loginInfo.jininCd : ''
}

export const anotherEigyoshoCtrlFlg = (state) => {
  return state.loginInfo !== null ? state.loginInfo.taeigyoshoSousaKanouFlg : false
}

export const helpUseFlg = (state) => {
  return state.loginInfo !== null ? state.loginInfo.helpUseFlg : false
}

export const sysFlg = (state) => {
  return state.loginInfo !== null ? state.loginInfo.sysFlg : false
}

export const loginInfo = (state) => {
  return state.loginInfo
}

export const goingToUrl = (state) => {
  return state.goingToUrl.url
}
